import clsx from 'clsx'
import NextImage from 'next/legacy/image'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import { useTranslate } from '../../contexts/TranslationContext'
import SvgArrowSlim from '../../svg/icons/ArrowSlim'
import { Button } from './Button'
import style from './CardMedia.module.sass'
import { Hidden } from './Hidden'

type CardMediaProps = {
	title: string
	lead?: string
	url: string
	imageUrl?: string
}

export const CardMedia: FunctionComponent<CardMediaProps> = ({ title, lead, url, imageUrl }) => {
	const translate = useTranslate()
	return (
		<div className={style.cardMediaWrapper}>
			<Link href={url} className={style.cardMedia} title={title}>
				{lead ? (
					<h2 className={style.title}>{title}</h2>
				) : (
					<div className={style.title}>
						{title}
						<Hidden breakpoint="mobileUp">
							<Button
								ariaLabel={translate('cardMedia.button')}
								iconButtonStyle={{ color: 'white', size: 'small' }}
								icon={{ aloneStanding: true, fillPrimary: true }}
								label={<SvgArrowSlim />}
							/>
						</Hidden>
					</div>
				)}
				<div className={style.body}>
					<div className={clsx(style.title, style.titleSmall)}>{title}</div>
					{lead && <p className={style.paragraph}>{lead}</p>}
					<span className={style.cardButton}>
						<Button
							ariaLabel={translate('cardMedia.button')}
							iconButtonStyle={{ color: 'white', size: 'small' }}
							icon={{ aloneStanding: true, fillPrimary: true }}
							label={<SvgArrowSlim />}
						/>
					</span>
				</div>
				<Hidden breakpoint="mobileUp">
					{imageUrl && (
						<div className={style.imageWrapper}>
							<NextImage
								src={imageUrl}
								alt={translate('alternativeText.ingredientCategory')}
								objectFit="cover"
								width={330}
								height={60}
								sizes="75vw"
							/>
						</div>
					)}
				</Hidden>
				<Hidden breakpoint="mobileDown">
					{imageUrl && (
						<div className={style.imageWrapper}>
							<NextImage
								src={imageUrl}
								alt={translate('alternativeText.ingredientCategory')}
								layout="fill"
								objectFit="cover"
								priority
							/>
						</div>
					)}
				</Hidden>
			</Link>
		</div>
	)
}
